import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import { IBaseDataReport } from '@/Interfaces/Attribution/Report.interface';
import { IPixelReportRecord } from '@/Interfaces/Attribution/ReportRecord.interface';
import { IControlOption } from '@/Interfaces/ControlOption.interface';

export const mapEventsList = ({ report }: IBaseDataReport<IPixelReportRecord>): IControlOption[] => {
  return report.map(record => ({
    value: record[BeeswaxReportProperties.EVENT_ID],
    label: record[BeeswaxReportProperties.EVENT_NAME],
  }));
};
